'use client';

export { PickupPointPicker, type PickupPointPickerProps } from './ui/pickup-point-picker';
